import { render, staticRenderFns } from "./resourcesCountCard.vue.html?vue&type=template&id=0acd9cb6&"
import script from "./resourcesCountCard.ts?vue&type=script&lang=ts&"
export * from "./resourcesCountCard.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports